<template>
    <div>
        <template
            v-for="(property, index) in properties_object"
        >
            <v-divider
                v-if="index !== 0"
                class="mx-4"
            ></v-divider>

            <summary-breakdown
                class="py-3 px-4"
                :object="benefits"
                :property="property"
                :key="'property-' + index"
                :small="small"
                show-secondary-labels
            ></summary-breakdown>

        </template>

        <v-divider></v-divider>

        <template
            v-for="(property, index) in properties"
        >
            <summary-value
                :key="index"
                class="py-3 px-4"
                :object="benefits"
                :property="property"
                :small="small"
                :greyed="isGreyed(property)"
                :inverted="isInverted(property)"
            ></summary-value>

            <v-divider></v-divider>
        </template>
    </div>
</template>

<script>
    import SummaryValue from "../../../Global/SummaryValue";
    import SummaryBreakdown from "../../../Global/SummaryBreakdown";

    import MyCoverMixin from "../../mycover";

    export default {
        name: 'My-Cover-Summary-Advisor',

        components: {
            SummaryValue,
            SummaryBreakdown
        },

        mixins: [
            MyCoverMixin
        ],

        props: {
            'mobile': {
                type: Boolean,
                default: false,
            },
            'small': {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                properties_object: [
                    {
                        'label': '',
                        'values': [
                            'advisorTotalCommissionFirstYear',
                            'lppCommission',
                            'initialAdvisorCommission'
                        ]
                    },
                    {
                        'label': '',
                        'values': [
                            'advisorRenewalCommission',
                        ]
                    },
                    {
                        'label': '',
                        'values': [
                            'advanceOnExecutorFees',
                        ]
                    },
                    {
                        'label': '',
                        'values': [
                            'advisorTotalShareOfFees',
                            'advisorShareOfLppFee',
                            'contributionToBookValue'
                        ]
                    }
                ],
                properties: [],
            }
        },

        methods: {
            isGreyed(property) {
                return property === 'advisorRenewalCommission';
            },
            isInverted(property) {
                return property === 'advisorTotalShareOfFees';
            }
        }
    }
</script>
